import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper
} from '@mui/material';

const TermsConditionsPrint = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* Header */}
      <Box sx={{ py: 4, backgroundColor: '#6B7280', color: 'white', textAlign: 'center' }}>
        <Container>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
            Austnews Design & Print Terms and Conditions
          </Typography>
        </Container>
      </Box>

      {/* Content */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper elevation={3} sx={{ p: { xs: 3, md: 6 } }}>
          
          {/* Definitions */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3 }}>
            Definitions
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            These Terms and Conditions shall govern every design and/or print order and shall constitute a contract between Austnews and the Business. By placing an order or design and/or print services, all Businesses agree to be bound by the Terms and Conditions of Austnews.
          </Typography>

          {/* Conditions */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Conditions
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            In Our Terms and Conditions, the following words and phrases have the following meanings:
          </Typography>
          
          <Box sx={{ pl: 3, mb: 3 }}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"Austnews", "Our", "We" and "Us"</strong>, refers to our Company.
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"You", "Your" and "Customer"</strong> refers to the organisation, you, the person placing an order and accepting the Austnews Design & Print Terms and Conditions.
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"Quote"</strong> means a written quotation for the goods and/or services to be provided to the Customer by Austnews.
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"Price"</strong> means the price payable for the goods and/or services as specified in the quote.
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"Order"</strong> means a request or order (whether written or verbal) for design and/or print of goods and/or services.
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"Job"</strong> means all goods and/or services to be supplied to the Customer as described on the order, quote or tax invoice.
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              <strong>"Goods"</strong> means any and all goods and services (including design, print items and electronic files) to be supplied to the Customer.
            </Typography>
          </Box>

          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer warrants that the person entering into an agreement, by placing an order and approving the final proof, is authorised to do so on behalf of the Customer, person or organisation. Austnews will accept no liability or responsibility if an unauthorised person places an order. In such a case, the Customer accepts liability for payment of the order and the full cost of the advertisement remains payable.
          </Typography>

          {/* Pricing and Quotes */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Pricing and Quotes
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Advertised prices may be varied by Austnews at any time, effective from the time nominated by Austnews and such varied prices will apply from that nominated date excluding any existing orders.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            All quoted prices are valid for 30 days from the date issued.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            All quoted prices include the Goods and Services Tax (GST).
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The placement of an order, or approval of a quote, for goods or services offered by Austnews and validated by either the Customer's signature on the quote, or Customer email or Customer verbal acceptance (in the case of work with urgent timelines) constitute acceptance of the quote and agreement to fully comply with all the Terms and Conditions.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The quote is an estimate based on an hourly rate. We work very hard to stay on budget and our quoting is typically very accurate. We will always contact you before proceeding beyond the original quoted price, however if your project goes over budget you will be billed at an hourly rate.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            If Austnews feels that any item requested by the Customer does not fit within the initial brief, the Customer may be charged additional fees. The item will either be quoted separately or charged as an extra, at full hourly rates.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Austnews reserves the right to correct any error in a quote whether technical, stenographic or otherwise.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Austnews will only commence a job when the Customer gives approval for the final artwork proof. If the Customer would like to receive a hard copy proof an additional cost of $10 including GST will be added to your order.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            If the Customer does not wish to proceed with an Order after receiving a proof, a fee of $90 including GST will be charged to cover design and administrative costs.
          </Typography>

          {/* Payment */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Payment
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer agrees to pay accounts rendered in accordance with its standard payment terms or as set out in the tax invoice.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            In some instances, Austnews may require the Customer to pay up to a 50% deposit or full payment on completion, but before delivery of a job.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Unless otherwise agreed in writing, invoices overdue by 28 days or more will be subject to an overdue fee of $25+GST per invoice.
          </Typography>

          {/* Delivery */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Delivery
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Many of Austnews' prices, where specified, include delivery to one location nationwide. This does not include insurance. A Customer needs to request insurance in writing and pay for it if this is required.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Additional delivery fees for special arrangements, such as for faster delivery, will be changed to the Customer.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer shall make all necessary arrangements to take delivery of the Goods whenever they are tendered for delivery. If the Customer is unable to take delivery of the Goods as arranged then Austnews shall be entitled to charge a reasonable fee for redelivery.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Austnews shall not be liable for any loss or damage whatsoever due to failure by Austnews to deliver the Goods (or any of them) promptly or at all, where due to circumstances beyond the control of Austnews.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Every effort is made to deliver your goods as soon as possible. The date of completion is an estimate only and Austnews will be under no liability for any loss or damage if completion is not effected by that date.
          </Typography>

          {/* Copy and Material */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Copy and Material
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            When accepting artwork proofs, the Customer is held fully responsible for accepting all content.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            This includes design, spelling, grammar and quality. It is the Customer's responsibility to request another copy if the proof is difficult to read or if changes are required. The Customer's final accepted proof is what will be printed. There will be no reprints at Austnews' expense.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            It is the Customer's responsibility to ensure that any design that is submitted does not violate Australian law. Austnews will assume the artwork or content the Customer submits is legally the Customer's property and the Customer indemnifies Austnews accordingly.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Laser proofs, digital proofs and screen proofs are not 100% accurate and variation may occur due to printing method, type of proof and the medium that the artwork is printed on. Austnews attempts to minimise variations as best as possible and cannot be held responsible for any deviation from the Customer's expectations as long as it is fit for the purpose.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Whilst all care is taken, print colour may vary from print to reprint, stock to stock, front to back and job to job. Therefore, Austnews accepts no responsibility for these colour variations in differentiating printing processes or stock.
          </Typography>

          {/* Copyright */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Copyright
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Unless the Customer and Austnews agree otherwise, the copyright in all Goods created by Austnews is the property of Austnews.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer retains the copyright to data, files and graphic logos provided to Austnews and grant Austnews the rights to publish and use such material.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer must obtain permission and rights to use any information or files that are copyrighted by a third party. The Customer warrants to Austnews that the Customer has copyright in or a licence to authorise Austnews to reproduce all artworks (in electronic form or otherwise) supplied by the Customer to Austnews for the purpose of the Job. The Customer expressly authorises Austnews to reproduce all and any of such artworks for the purposes of the Job.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer indemnifies and agrees to keep Austnews indemnified against all liability, losses or expenses incurred by Austnews in any way directly or indirectly connected with any breach of copyright or of any rights in relation to copyright in any artwork supplied by the Customer.
          </Typography>

          {/* Ownership */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Ownership
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Austnews owns and retains all copyright and other intellectual property rights in relation to any Job produced by us. Any and all design, files, layouts, and other items related to the Job remain the full ownership of Austnews and is therefore covered by Australian copyright laws.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer does not acquire ownership to any Jobs (including designs) produced by Austnews.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            No authority is given to any persons or business wishing to reproduce or duplicate any part of any Job through any other party in any way shape or form. Design fees are charged based on labour only and do not offer the customer any copyright to that design. Reproduction of any Job produced by Austnews will not be tolerated unless produced through Austnews. Such conduct will result in direct breach of copyright protection.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            This clause does not in any way derogate from the Customer's obligations or liabilities in relation to such Jobs.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Customer also acknowledges that Austnews has the right to use Jobs and/or the Customer's name and/or logos within any of its other printed and digital marketing materials including, but not limited to, brochures, websites and social media sites.
          </Typography>

          {/* Privacy Statement */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Privacy Statement
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Austnews collects personal information about the Customer, including for example the Customer's name and contact details. We collect and use that information to provide the Customer with our goods and services and to improve these goods and services.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Austnews may, from time to time, contact the Customer about goods, services or promotions which may be of interest to the Customer.
          </Typography>

          {/* Legal */}
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 600, color: '#7B2CBF', mb: 3, mt: 5 }}>
            Legal
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Agreements shall be constructed under the laws of the State of Queensland and any disputes will be subject to the jurisdiction of the Queensland Courts.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Advertiser indemnifies Austnews its directors, employees and agents against all claims, demands, proceedings, costs (including solicitors and own client costs), expenses, damages awards, judgments and any other liability whatsoever arising wholly or partially, directly or indirectly, from or in connection with an an advertisement that does not conform to the undertaking in paragraph above.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The Advertiser agrees at the Advertiser's own expense, to promptly defend and continue the defence of any such claim, demand action or proceeding that may be brought against Austnews, provided that Austnews shall promptly notify the Advertiser with respect thereto. The Advertiser shall reimburse Austnews for any amount paid by Austnews in settlement of claims or in satisfaction of judgements obtained by reason of publication of such advertising copy, together with all expenses incurred in connection therewith, including but not limited to, reasonable legal fees and court costs.
          </Typography>

        </Paper>
      </Container>

      {/* Footer */}
      <Box sx={{ py: 4, backgroundColor: '#6B7280', color: 'white', textAlign: 'center' }}>
        <Container>
          <Typography variant="body2">
            Copyright Australian Newsletter Services Pty Ltd 2024 |{' '}
            <Box
              component="a"
              href="/design-print"
              sx={{
                color: 'white',
                textDecoration: 'underline',
                '&:hover': {
                  color: '#E0E0E0'
                }
              }}
            >
              Back to Design + Print
            </Box>
            {' '}| All Rights Reserved
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            QAssure Number: 11954 | Accredited GITC Supplier: Q-6019 | ABN 24 010 367 478
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default TermsConditionsPrint;

